export const HOMEPAGE_VERSION_NEW = 'new'
export const HOMEPAGE_VERSION_LEGACY = 'legacy'

/** 将 SQL 主页配置限制为新版或旧版；缺省使用旧版。 */
export function normalizeHomepageVersion(value) {
  return String(value || '').trim().toLowerCase() === HOMEPAGE_VERSION_NEW
    ? HOMEPAGE_VERSION_NEW
    : HOMEPAGE_VERSION_LEGACY
}
